// Every displayed date across the app should read dd/mm/yyyy, not whatever the browser's locale
// happens to default to (toLocaleDateString() varies: mm/dd/yyyy in en-US, yyyy-mm-dd elsewhere).
// A plain "YYYY-MM-DD" string is parsed as local midnight, not UTC — new Date('YYYY-MM-DD') alone
// parses as UTC midnight, which renders as the previous day in negative-UTC-offset timezones.
export function formatDdMmYyyy(input: string | Date): string {
  const date = typeof input === 'string' ? new Date(input.includes('T') ? input : `${input}T00:00:00`) : input;
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}
